import React, { useMemo } from 'react';
import { Tag, TagProps } from '@chakra-ui/react';
import { UserCoreFragment, UserFlagType, UserState } from '../../../../__generated__/graphql';
import './userCoreFragments';
import { getTagsForUser } from './getUserTags';
import { twMerge } from 'tailwind-merge';
import { chakraToTailwind } from '../../../theme/custom/custom-theme-colors';
type Props = {
  user: UserCoreFragment;
  showFree?: boolean;
};

interface Tag extends TagProps {
  content: string;
  bg: string;
  color: string;
}

export { getTagsForUser };

const _classNames = ['bg-highlight', 'bg-gray-500'];

function UserTags({ user, showFree }: Props) {
  const tags = useMemo(() => getTagsForUser(user, showFree), [user, showFree]);

  return (
    <>
      {tags.map(({ content, ...tag }, index) => (
        <div
          {...tag}
          key={index}
          className={twMerge(
            'flex justify-center items-center h-[20px] typography-action-sm font-bold p-[4px] uppercase',
            `bg-${chakraToTailwind(tag.bg)} text-${chakraToTailwind(tag.color)}`,
          )}
        >
          {content}
        </div>
      ))}
    </>
  );
}

export default UserTags;
